const audioBands = [
  { from: -60, color: '#58c978' },
  { from: -6, color: '#e9cf45' },
  { from: 0, color: '#ef5a5a' }
];

/**
 * VU LED compacto.
 *
 * Quando `levels` não é informado, `leds` distribui a quantidade pedida entre
 * min e max. É a forma adequada para um indicador mínimo de 5 LEDs.
 */
export const vuLedCompact = {
  element: 'chart',
  id: 'tutorial-vu-led-compact',
  type: 'vu-led',
  channels: '2.0',
  gap: false,
  width: 160,
  height: 100,
  plotOptions: {
    fast: {
      min: -24,
      max: 6,
      leds: 5,
      orientation: 'vertical',
      showScale: false,
      bands: audioBands
    }
  },
};

/**
 * VU LED com escala irregular explícita.
 *
 * Cada LED representa exatamente um limiar. O estado abaixo do primeiro ponto
 * equivale a -∞, portanto todos os LEDs ficam apagados.
 */
export const vuLedScale = {
  element: 'chart',
  id: 'tutorial-vu-led-scale',
  type: 'vu-led',
  channels: '2.0',
  gap: false,
  width: 160,
  height: 132,
  plotOptions: {
    fast: {
      min: -36,
      max: 6,
      levels: [-36, -24, -12, -6, 0, 3, 6],
      orientation: 'vertical',
      showScale: true,
      bands: audioBands
    }
  },
};

/**
 * Level Meter contínuo. A dimensão externa é livre; por exemplo, `height: '100%'`
 * permite usar o meter vertical ao lado de um vídeo dentro de um container com
 * altura definida.
 */
export const levelContinuous = {
  element: 'chart',
  id: 'tutorial-level-continuous',
  type: 'level-meter',
  style: 'continuous',
  orientation: 'vertical',
  channels: '2.0',
  gap: false,
  width: 128,
  height: 220,
  plotOptions: {
    fast: {
      min: -60,
      max: 6,
      ticks: [-60, -36, -24, -12, -6, 0, 3, 6],
      showScale: true,
      peakHold: true,
      bands: audioBands
    }
  },
};

/**
 * Level Meter segmentado. No vertical os segmentos são retângulos horizontais
 * compridos, como em medidores de rack e consoles de áudio.
 */
export const levelSegments = {
  element: 'chart',
  id: 'tutorial-level-segments',
  type: 'level-meter',
  style: 'segments',
  orientation: 'vertical',
  channels: '2.0',
  gap: false,
  width: 128,
  height: 220,
  plotOptions: {
    fast: {
      min: -60,
      max: 6,
      ticks: [-60, -36, -24, -12, -6, 0, 3, 6],
      segmentSize: 5,
      segmentGap: 2,
      showScale: true,
      peakHold: true,
      bands: audioBands
    }
  },
};

/**
 * Level Meter por pontos. Este exemplo é horizontal e empilha L/R em duas
 * linhas, mostrando como o componente pode ocupar a largura de um vídeo.
 * No tutorial ele é alimentado por getDisplayMedia, não pelo microfone.
 */
export const levelDotsTab = {
  element: 'chart',
  id: 'tutorial-level-dots-tab',
  type: 'level-meter',
  style: 'dots',
  orientation: 'horizontal',
  channels: '2.0',
  rows: 2,
  gap: false,
  width: 420,
  height: 150,
  plotOptions: {
    fast: {
      min: -60,
      max: 6,
      ticks: [-60, -36, -24, -12, -6, 0, 3, 6],
      dotSize: 4,
      dotGap: 2,
      showScale: true,
      peakHold: true,
      bands: audioBands
    }
  },
};

export const vuLedQuickCharts = [
  vuLedCompact,
  vuLedScale
];

export const levelMeterQuickCharts = [
  levelContinuous,
  levelSegments,
  levelDotsTab
];

export default [
  ...vuLedQuickCharts,
  ...levelMeterQuickCharts
];
